import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import Accordions from '~/components/blocks/acf/Accordions';

const AccordionsBlock = ({
    attributes,
    globalBlockOptions: { globalBlockOptions },
    blockAccordions
}) => (
    <Accordions
        {...{
            ...blockAccordions,
            globalBlockOptions,
            attributes
        }}
    />
);

AccordionsBlock.propTypes = {
    blockAccordions: PropTypes.shape({
        title: PropTypes.string,
        accordions: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                content: PropTypes.string.isRequired
            })
        ).isRequired
    }).isRequired
};

export default AccordionsBlock;

export const fragment = graphql`
    fragment AccordionsBlockFragment on WpAcfAccordionsBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockAccordions {
            title
            accordions {
                title
                content
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Accordions',
        props: {
            name: 'acf/accordions',
            blockAccordions: {
                title: 'Accordion Block Title',
                accordions: [
                    {
                        title: 'Lorem Ipsum',
                        content:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
                    },
                    {
                        title: 'A title for the accordion',
                        content: 'Some content for this accordion'
                    },
                    {
                        title: 'FAQ',
                        content:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
                    }
                ]
            }
        }
    }
];
